export default __webpack_public_path__ + "static/impact-photo-Joey2-148d71250f3951edb7e761911e3062fb.jpg";